//
export default [
    {
        name: "is_pyme",
        props: {
            chips: true,
            items: [
                {
                    text: "Si",
                    value: '1',
                },
                {
                    text: "No",
                    value: '0',
                },
            ],
            label: "Pyme",
            noObject: true,
        },
        type: "select",
    },    
]